/**
 * Created by daniel.gonzalez on 6/15/15.
 */

'use strict';

var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var deepLink = require('../../../global/core/deepLink');
var mobileCheck = require('bunsen/helpers/mobileCheck');
var referrerHelpers = require('../../../global/tracking/referrerHelpers');
var defaultCookieSettings = require('bunsen/helpers/dibsCookies').defaultCookieSettings;

require('bunsen/libraries/plugins/jquery.cookie');

module.exports = {
    checkSettings: function () {
        return mobileCheck.iPhone() && !$.cookie('dibsMobileInterstitial') && deepLink.pageSupported();
    },

    shouldShowAd: function () {
        return this.checkSettings() && !referrerHelpers.isPlaReferrer();
    },

    setCookie: function () {
        $.cookie('dibsMobileInterstitial', true, _.extend({expires: 1}, defaultCookieSettings));
    }
};



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/mobileAds/helpers/mobileAdsHelpers.js
// module id = 2023
// module chunks = 63